import cookies from 'js-cookie';

export function removeSessionCookies() {
  const keysToRemove = ['dismissedPromoteQty2'];

  keysToRemove.forEach((key) => cookies.remove(key));
}
